// Form-related type definitions

// Form status enum
export const FORM_STATUS = {
  DRAFT: 'DRAFT',
  PUBLISHED: 'PUBLISHED',
  CLOSED: 'CLOSED',
};

// Form structure
export const FORM_STRUCTURE = {
  id: null, // string
  title: '', // string
  description: '', // string
  status: FORM_STATUS.DRAFT, // FORM_STATUS
  settings: {
    collectEmail: false, // boolean
    allowMultipleResponses: false, // boolean
  },
  questions: [], // Array<Question>
  createdAt: null, // string (ISO date)
  publishedAt: null, // string (ISO date) | null
  closedAt: null, // string (ISO date) | null
};

// Question structure
export const QUESTION_STRUCTURE = {
  id: null, // string | null (null for new questions)
  type: '', // QUESTION_TYPES
  title: '', // string
  description: null, // string | null
  required: false, // boolean
  order: 0, // number
  config: null, // object | null (depends on question type)
};

// Form settings structure
export const FORM_SETTINGS_STRUCTURE = {
  collectEmail: false,
  allowMultipleResponses: false,
};

// Question config structures for different types
export const QUESTION_CONFIGS = {
  SHORT_TEXT: {
    uiConfig: {},
    minLen: 1,
    maxLen: 100,
  },
  PARAGRAPH: {
    uiConfig: {},
    minLen: 1,
    maxLen: 1000,
  },
  MULTIPLE_CHOICE: {
    uiConfig: {},
    options: [], // Array<string>
    maxSelections: 1,
    minSelections: 1,
  },
  CHECKBOX: {
    uiConfig: {},
    options: [], // Array<string>
    maxSelections: null, // number | null
  },
  DROPDOWN: {
    uiConfig: {},
    options: [], // Array<string>
  },
  STATEMENT: null, // No config needed
};
